import { render, staticRenderFns } from "./NewCguDialog.vue?vue&type=template&id=398c975d&scoped=true"
import script from "./NewCguDialog.vue?vue&type=script&lang=ts"
export * from "./NewCguDialog.vue?vue&type=script&lang=ts"
import style0 from "./NewCguDialog.vue?vue&type=style&index=0&id=398c975d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "398c975d",
  null
  
)

export default component.exports